import { memo, useEffect, useState } from 'react';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import HealthService from 'src/services/health.service';
import TenantService from 'src/services/tenant.service';
import UserService from 'src/services/user.service';
import { useUser } from 'src/stores';
import useHealth from 'src/stores/health/health.store';
import useTenant from 'src/stores/tenant/tenant.store';
import { IBaseProps } from 'src/types/common.type';

const svUser = new UserService();
const svHealth = new HealthService();
const svTenant = new TenantService();

function InitAppProvider({ children }: IBaseProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  // const { refresh } = useRefresh();
  const { changeUser } = useUser();
  const { changeHealth } = useHealth();
  const { changeTenant, tenant, changeListTenant } = useTenant();

  useEffect(() => {
    fetchInit();
  }, []);

  const fetchInit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const account = await svUser.profile();
      changeUser(account);

      // check health
      const health = await svHealth.get();
      changeHealth(health);

      const listTenant: any = await svTenant.list({});
      changeListTenant(listTenant);

      if (tenant) {
        const newTenant = await svTenant.detail(tenant.id);
        changeTenant(newTenant);
      }

      setInit(true);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  if (loading || !init) return <SpinnerLoader bg={false} />;

  return children;
}

export default memo(InitAppProvider);
